import React from "react";
import { Button } from "react-bootstrap";
import axios from "axios";

import { useState } from "react";

import LoadingSpinner from "./LoadingSpinner";

const MessageTableRow = (props) => {    

    const { _id, post } = props.obj;

    const [result, setResult] = useState("");
    const [isLoading, setIsLoading] = useState(false);

    const progressMessage = () => {
        setIsLoading(true);
        axios
            .post(
                "https://peaceo.hopto.org/messages/progress-message/" + _id, 
                post, { timeout: 129600000 })
            .then((res) => {
                if (res.status === 200) {
                    setIsLoading(false)
                    setResult(res.data.message);
                } else Promise.reject();
            })
            .catch((err) => {
                alert("Something went wrong.");
                setIsLoading(false);
            });
    };

    const deleteMessage = () => {
        axios
            .delete(
                "https://peaceo.hopto.org/messages/delete-message/" + _id)
            .then((res) => {
                if (res.status === 200) {
                    alert("successfully deleted message.");
                    setTimeout(() => window.location.reload());
                } else Promise.reject();
            })
            .catch((err) => alert("Something is went wrong."));
    };

    return (
        <tr>
            <td>
                {post}
            </td>
            <td>
                <Button onClick={progressMessage}
                    disabled={isLoading}
                    size="sm" variant="info">
                    Progress
                </Button>
                <Button onClick={deleteMessage}
                    disabled={isLoading}
                    size="sm" variant="light">
                    Delete
                </Button>
                {isLoading && <LoadingSpinner/>}
            </td>
            <td>{result}</td>
        </tr>
    );
};

export default MessageTableRow;